import { Tag, Typography } from '@project44/manifest-ds';

import { scopedT } from '../../utils/helpers/scopedT';
import { Tooltip } from '../Tooltip';

import { Item, List } from './styles';

interface ReferenceKeyItemProps {
  onTagClick?: (value: string) => void;
  data: string[];
  label: string;
}

export const ReferenceKeyItem = ({
  label,
  data,
  onTagClick,
}: ReferenceKeyItemProps) => {
  const t = scopedT();
  return (
    <Item data-testid="reference-key-item">
      <Typography variant="subtext">{label}</Typography>
      <List>
        {data.map((value) => (
          <Tooltip message={t('copy')} messageClicked={t('copied')} key={value}>
            <Tag
              onClick={() => onTagClick?.(value)}
              data-testid="reference-key-item-click"
              css={{ cursor: 'pointer', maxWidth: '400px' }}
            >
              {value}
            </Tag>
          </Tooltip>
        ))}
      </List>
    </Item>
  );
};
